import { ProductKeys3P } from '@atlassian/rovo-connectors-config/types';
import type { ProductKeys3P as ProductKeys3PType } from '@atlassian/rovo-connectors-config/types';

const PRODUCT_KEY_VALUES = new Set<string>(Object.values(ProductKeys3P));

export const isValidProductKey = (key: string): key is ProductKeys3PType =>
	PRODUCT_KEY_VALUES.has(key);
